var map = {
  "./": "82358",
  "./destroy": "27172",
  "./destroy.js": "27172",
  "./edit": "12720",
  "./edit.js": "12720",
  "./index": "82358",
  "./index.js": "82358",
  "./new": "9964",
  "./new.js": "9964",
  "./show": "99653",
  "./show.js": "99653",
  "./upload": "60901",
  "./upload.js": "60901"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 28910;
